export default __webpack_public_path__ + "static/media/autoconsumo-ahorro-mvl.79de5c91.png";